export const SHOPIFY_MOVE_SLICE_NAME = "shopifyMove"
